<template>
  <div style="height: 100%">
    <v-container>
      <v-card class="pa-2">
        <v-row align="center" class="ml-1">
          <div>
            <v-icon color="#4B2A66">mdi-form-select</v-icon>
          </div>
          <div class="mx-3">Listar por:</div>
          <v-col class="d-flex" cols="12" md="3">
            <v-select
              v-model="numProducts"
              :items="lenProducts"
              label="Produtos por loja"
              solo
              hide-details
              dense
            />
          </v-col>
          <v-col class="d-flex" cols="12" md="3">
            <v-select
              v-model="numShops"
              :items="lenShops"
              label="Lojas por página"
              solo
              hide-details
              dense
            />
          </v-col>
          <v-spacer />
          <v-col
            v-if="!$store.state.logged"
            class="d-flex justify-end align-center"
          >
            <span class="text-subtitle-2 pr-2">Defina sua localização:</span>
            <v-btn
              icon
              color="#4B2A66"
              @click="$refs.getLocation.open()"
              class="mr-2"
            >
              <v-icon>mdi-map-marker</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-overlay v-model="loading">
        <v-progress-circular
          :size="100"
          :width="7"
          color="#4B2A66"
          indeterminate
        ></v-progress-circular>
      </v-overlay>

      <v-row dense v-if="!noResults">
        <v-col
          v-for="shop in searchResults"
          :key="shop.title"
          md="12"
          sm="12"
          cols="12"
        >
          <v-card class="elevation-5" height="auto">
            <v-row>
              <v-col cols="1" class="pa-0 ma-0 d-flex align-center">
                <v-avatar tile class="ml-5" @click="openShop(shop.url)">
                  <img :src="shop.photograph" />
                </v-avatar>
              </v-col>
              <v-col cols="auto" class="ml-5">
                <v-card-title @click="openShop(shop.url)">
                  {{ shop.shop_name }}
                </v-card-title>
              </v-col>
            </v-row>
            <v-divider />

            <div class="d-flex justify-center">
              <v-row style="max-width: 100%">
                <v-col
                  v-for="product in shop.products"
                  :key="product._id"
                  height="auto"
                  cols="6"
                  sm="3"
                  md="3"
                  set="product = product-1"
                >
                  <v-card @click="openProduct(product.url_product, shop.url)">
                    <img
                      :src="
                        product.images.length == 0
                          ? undefined
                          : product.images[0]
                      "
                      class="d-flex flex-column justify-space-between"
                      width="100%"
                      height="250px"
                    />
                    <v-card-title class="ma-0 pa-0 pl-2">
                      {{ product.product }}
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row dense v-show="visible">
        <v-col>
          <v-card class="elevation-5" height="auto">
            <v-row>
              <v-col cols="auto" class="d-flex">
                <div class="ml-3">
                  O Olhadela está em constante expansão, e em breve você
                  encontrará o que procura em sua cidade também! Convide
                  empresas locais para fazerem parte do olhadela!
                  <v-card-text>
                    Compartilhe:
                    <v-btn
                      v-if="!webShareApiSupported"
                      icon
                      target="_blank"
                      href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Folhadela.digital%2F"
                    >
                      <v-icon size="30" color="blue">mdi-facebook</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="!webShareApiSupported"
                      icon
                      target="_blank"
                      href="https://wa.me/?text=Olhadela%20-%20Sua%20Vitrine%20Digital%20para%20Encontrar%20o%20que%20Procura%20ou%20divulgar%20o%20seu%20Neg%C3%B3cio.%20Vamos%20l%C3%A1%20dar%20aquela%20Olhadela?%0Ahttps://olhadela.digital/"
                    >
                      <v-icon size="30" color="green">mdi-whatsapp</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="!webShareApiSupported"
                      icon
                      target="_blank"
                      href="https://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Folhadela.digital%2F"
                    >
                      <v-icon size="30" color="blue">mdi-linkedin</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="!webShareApiSupported"
                      icon
                      target="_blank"
                      href="https://pinterest.com/pin/create/button/?description=Olhadela+-+Sua+Vitrine+Digital+para+Encontrar+o+que+Procura+ou+divulgar+o+seu+Neg%C3%B3cio.+Vamos+l%C3%A1+dar+aquela+Olhadela%3F&media=https%3A%2F%2Fprodutos-olhadela.s3-sa-east-1.amazonaws.com%2Folhadela_logo.png&url=https%3A%2F%2Folhadela.digital%2F"
                    >
                      <v-icon size="30" color="red"
                        >mdi-pinterest</v-icon
                      > </v-btn
                    ><v-btn
                      v-if="!webShareApiSupported"
                      icon
                      target="_blank"
                      href="https://twitter.com/share?text=Olhadela+-+Sua+Vitrine+Digital+para+Encontrar+o+que+Procura+ou+divulgar+o+seu+Neg%C3%B3cio.+Vamos+l%C3%A1+dar+aquela+Olhadela%3F&url=https%3A%2F%2Folhadela.digital%2F"
                    >
                      <v-icon size="30" color="blue">mdi-twitter</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="webShareApiSupported"
                      icon
                      href="javascript:void(0)"
                      @click="share()"
                    >
                      <v-icon size="30" color="#4B2A66">mdi-share</v-icon>
                    </v-btn>
                  </v-card-text>
                </div>
              </v-col>
            </v-row>
            <v-divider />
          </v-card>
        </v-col>
      </v-row>

      <v-pagination
        v-model="currentPage"
        :length="numberShops"
        :total-visible="7"
        dense
      />
    </v-container>

    <GetLocation ref="getLocation" @haveCity="makeSearch($event)" />
  </div>
</template>

<script>
import GetLocation from "@/components/GetLocation.vue";

export default {
  name: "SearchResults",
  components: {
    GetLocation,
  },
  data: () => ({
    loading: true,
    visible: false,
    searchResults: [],
    currentPage: 1,
    numProducts: 4,
    numShops: 4,
    numberShops: undefined,
    lenShops: [
      { text: "4 lojas por página", value: 4 },
      { text: "10 lojas por página", value: 10 },
      { text: "20 lojas por página", value: 20 },
      { text: "30 lojas por página", value: 30 },
    ],
    lenProducts: [
      { text: "4 produtos por loja", value: 4 },
      { text: "10 produtos por loja", value: 10 },
      { text: "20 produtos por loja", value: 20 },
    ],
  }),
  computed: {
    noResults() {
      return this.loading == false && this.searchResults.length == 0;
    },
    webShareApiSupported() {
      return navigator.share;
    },
  },
  methods: {
    makeSearch(visitor_city_id) {
      this.loading = true;
      const searchQuery = this.$route.params.searchQuery;
      const offset = (this.currentPage - 1) * this.numShops;
      let options = {};
      if (!this.$store.state.logged) {
        options = { params: { city_id: visitor_city_id } };
      }
      this.$axios
        .get(
          `/search/${searchQuery}/${this.numShops}/${offset}/${this.numProducts}`,
          options
        )
        .then((response) => {
          if (response.data[0].length == 0) {
            this.searchResults = [];
            this.visible = true;
          } else if (response.data[0].length > 0) {
            this.visible = false;
            this.searchResults = response.data[0];
            this.numberShops = response.data[1];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openShop(shop_url) {
      this.$router.push({
        name: "shop",
        params: { shop_url: shop_url },
      });
    },
    openProduct(product_url, shop_url) {
      this.salvar = true;
      this.salvo = false;
      this.$router.push({
        name: "product",
        params: {
          shop_url: shop_url,
          product_url: product_url,
        },
      });
    },
    share() {
      if (navigator.share !== undefined) {
        navigator
          .share({
            title: "Olhadela",
            text:
              "Olhadela - Sua Vitrine Digital para Encontrar o que Procura ou divulgar o seu Negócio. Vamos lá dar aquela Olhadela?",
            url: "https://olhadela.digital/",
          })
          .then(() => console.log("Successful share"))
          .catch((error) => console.log("Error sharing", error));
      }
    },
  },
  mounted() {
    document.title = `Olhadela - Resultados da Busca`;
    if (this.$store.state.logged) {
      this.makeSearch();
    }
  },
  watch: {
    numProducts() {
      this.makeSearch();
    },
    numShops() {
      this.makeSearch();
    },
    currentPage() {
      this.makeSearch();
    },
    "$route.params.searchQuery": function () {
      this.makeSearch();
    },
  },
};
</script>
